import { feedback } from "../constants";
import styles from "../style";
import Stats from "./Stats";
import { useEffect } from "react";

const Testimonials = () => {
  useEffect(() => {
    const cards = Array.from(document.querySelectorAll('.testimonial-card'));
    if (!cards.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const idx = Number(entry.target.datasetIdx || 0);
          setTimeout(() => entry.target.classList.add('is-visible'), idx * 70);
        }
      });
    }, { threshold: 0.12 });
    cards.forEach((c, i) => {
      c.setAttribute('data-idx', String(i));
      obs.observe(c);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <section id="clients" className={`${styles.flexCenter} flex-col relative sm:mb-20 mb-6 sm:my-24 my-6 px-6 py-10`}>
      <div className="w-full max-w-6xl mx-auto text-center">
        {/* Move statistics into this section */}
        <Stats />
        <p className="text-sm text-dimWhite mb-3">Testimonials</p>
        <h2 className="text-4xl sm:text-6xl font-extrabold text-gradient mb-8">Hear from our clients</h2>
        <p className="text-base text-dimWhite/80 max-w-2xl mx-auto mb-10">Every review you read here is genuine—feel free to see what our clients have to say.</p>

        {/* Responsive: small screens show a single-column grid; md+ shows 2 marquee columns with opposite directions */}
        <div className="block md:hidden">
          {/* Mobile: use a short vertical marquee (duplicated track) so cards animate while keeping same height */}
          <div className="marquee-mobile">
            <div className="marquee-track-mobile">
              {[...feedback, ...feedback].map((item, idx) => (
                <article key={`m-${String(item.id)}-${idx}`} data-idx={idx} className="testimonial-card bg-primary/40 border border-[#111417] rounded-2xl p-6 shadow-xl">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-black font-semibold">{String(item.name).charAt(0).toUpperCase()}</div>
                    <div>
                      <h4 className="text-sm font-semibold text-white">{item.name}</h4>
                      <div className="text-xs text-dimWhite/70">{item.location}</div>
                    </div>
                  </div>
                  <div className="text-sm text-dimWhite leading-relaxed">{item.content}</div>
                </article>
              ))}
            </div>
          </div>
        </div>

        <div className="hidden md:flex gap-6">
          {/* split feedback into two columns */}
          {(() => {
            const left = feedback.filter((_, i) => i % 2 === 0);
            const right = feedback.filter((_, i) => i % 2 === 1);
            const leftDup = [...left, ...left];
            const rightDup = [...right, ...right];

            return (
              <>
                <div className="marquee-col flex-1">
                  <div className="marquee-track-up">
                    {leftDup.map((item, idx) => (
                      <article key={`l-${String(item.id)}-${idx}`} className="testimonial-card bg-primary/40 border border-[#111417] rounded-2xl p-6 shadow-xl">
                        <div className="flex items-start gap-4 mb-4">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-black font-semibold">{String(item.name).charAt(0).toUpperCase()}</div>
                          <div>
                            <h4 className="text-sm font-semibold text-white">{item.name}</h4>
                            <div className="text-xs text-dimWhite/70">{item.location}</div>
                          </div>
                        </div>
                        <div className="text-sm text-dimWhite leading-relaxed">{item.content}</div>
                      </article>
                    ))}
                  </div>
                </div>

                <div className="marquee-col flex-1">
                  <div className="marquee-track-down">
                    {rightDup.map((item, idx) => (
                      <article key={`r-${String(item.id)}-${idx}`} className="testimonial-card bg-primary/40 border border-[#111417] rounded-2xl p-6 shadow-xl">
                        <div className="flex items-start gap-4 mb-4">
                          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-black font-semibold">{String(item.name).charAt(0).toUpperCase()}</div>
                          <div>
                            <h4 className="text-sm font-semibold text-white">{item.name}</h4>
                            <div className="text-xs text-dimWhite/70">{item.location}</div>
                          </div>
                        </div>
                        <div className="text-sm text-dimWhite leading-relaxed">{item.content}</div>
                      </article>
                    ))}
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
